// @ts-nocheck

import React, { useEffect, useRef, useState } from 'react'
import { radiusList } from '../../data/data';
import MyMapComponent from './MyMapComponent';
import { getAddressFromCoordinates, setDropdownSelectedValue } from '../../utils';
import GoogleSearchPlaceInput from './GoogleSearchPlaceInput';
import DropDown from '../../global/ui/dropDown';
import DropDownV2 from '../../global/ui/DropDownV2';

const DEFAULT_RADIUS = '50'

const CustomGooglePlaceSearchV2: React.FC<any> = (props) => {

    const dropdownRef = useRef<HTMLDivElement>(null);

    const [isOpen, setIsOpen] = useState(false);

    const [locationData, setLocationData] = useState<any>(null)
    const [selectedRadius, setSelectedRadius] = useState<any>(DEFAULT_RADIUS)

    const handleApply = () => {
        const obj = {
            location: locationData?.address || '',
            lat: locationData?.lat || '',
            lng: locationData?.lng || '',
            radius: selectedRadius || ''
        }
        if (props?.needExtraData) {
            obj['city'] = locationData?.city || '';
            obj['country'] = locationData?.country || '';
            obj['post_code'] = locationData?.post_code || '2000';
        }
        props?.onApply?.(obj);
        setIsOpen(false)
    }

    useEffect(() => {
        const obj = {
            address: props?.data?.location || '',
            lat: props?.data?.lat || '',
            lng: props?.data?.lng || '',
        }
        setLocationData(obj)
        setSelectedRadius(props?.data?.radius || DEFAULT_RADIUS)
    }, [JSON.stringify(props?.data)]);

    const handleMarkerDragEnd = event => {
        const { latLng } = event;
        const lat = latLng?.lat();
        const lng = latLng?.lng();
        getAddressFromCoordinates(lat, lng).then((response) => {
            setLocationData({
                address: response?.address || '',
                lat: lat || '',
                lng: lng || '',
                city: response?.city || '',
                country: response?.country || '',
                post_code: response?.post_code || ''
            })
        })
    };

    return (
        <div
            className="google-custom-search-v2-wrapper"
            style={{
                position: 'relative',
                marginTop: props?.isSupplier ? '-20px' : '0px',
            }}
        >
            {/* LABEL */}

            {(props?.label || props?.infoIcon) && (
                <div className="google-custom-search-v2-label-row">
                    <label className="google-custom-search-v2-label">
                        {props?.label || 'Location'}
                    </label>

                    {props?.infoIcon && (
                        <img
                            src={props?.infoIcon}
                            alt="info"
                            className="google-custom-search-v2-info-icon"
                        />
                    )}
                </div>
            )}

            {/* MAIN INPUT */}

            <div
                onClick={() => setIsOpen((prevState) => !prevState)}
                className={`google-custom-search-v2-box ${isOpen ? 'google-custom-search-v2-focused' : ''
                    }`}
            >
                {props?.data?.location ? (
                    <span className="google-custom-search-v2-value">
                        {props?.data?.location}
                    </span>
                ) : (
                    <span className="google-custom-search-v2-placeholder">
                        {props?.placeholder
                            ? props?.placeholder
                            : 'City or Postcode'}
                    </span>
                )}

                {props?.showDelete && (
                    <div
                        className="google-custom-search-v2-delete"
                        onClick={(evt) => {
                            evt.stopPropagation();
                            props?.onDelete();
                        }}
                    >
                        <img
                            className="cursor-pointer"
                            src={"/assets/images/delete-fill-inner-red.svg"}
                            alt=""
                        />
                    </div>
                )}
            </div>

            {/* OLD DROPDOWN SAME AS IT IS */}

            <div
                ref={dropdownRef}
                style={{
                    display: isOpen ? 'block' : 'none',
                    width: props?.hideRadius ? '445px' : props?.dropdownWidth ? props?.dropdownWidth : '800px',
                    borderRadius: 0
                }}
                className='custom-search-dropdown'
            >
                <div className='d-flex justify-content-between w-100'>
                    <span></span>

                    <span>
                        {props?.heading || 'Change Location'}
                    </span>

                    <button
                        type='button'
                        onClick={() => setIsOpen((prevState) => !prevState)}
                        className="close-btn shadow-none"
                        style={{ borderRadius: 0 }}
                    >
                        <img
                            src={"/assets/images/dismiss-cross-black.svg"}
                            alt=""
                        />
                    </button>
                </div>

                <div
                    style={
                        props?.contentStyle || {
                            paddingBottom: '20px',
                        }
                    }
                >
                    <div
                        className={
                            props?.hideRadius
                                ? 'align-content-center justify-content-between'
                                : 'd-flex align-content-center justify-content-between'
                        }
                    >
                        <div>
                            <p>
                                Search by city neighbourhood or zip code
                            </p>

                            <div className="form_group black-input mb-4">
                                <div className="input_box">
                                    <label htmlFor="location">
                                        Location
                                    </label>

                                    <GoogleSearchPlaceInput
                                        onSelect={(data) => {
                                            setLocationData((prevState) => ({
                                                ...prevState,
                                                address:
                                                    data?.address || '',
                                                lat:
                                                    data?.coordinates?.[0] ||
                                                    '',
                                                lng:
                                                    data?.coordinates?.[1] ||
                                                    '',
                                                city:
                                                    data?.city || '',
                                                country:
                                                    data?.country || '',
                                                post_code:
                                                    data?.post_code || '',
                                            }));
                                            setTimeout(() => {
                                                dropdownRef.current?.scrollTo({
                                                    top: dropdownRef.current.scrollHeight,
                                                    behavior: 'smooth',
                                                });
                                            }, 500);
                                        }}
                                        selectedAddress={
                                            locationData?.address || ''
                                        }
                                        inputStyle={{ borderRadius: 0 }}
                                    />
                                </div>
                            </div>

                            {!props?.hideRadius && (
                                <DropDownV2
                                    className="arrow-fill"
                                    data={radiusList}
                                    onSelect={(data) => setSelectedRadius(data?.value)}
                                    placeholder='Select radius'
                                    label='Select radius'
                                    selectedItems={setDropdownSelectedValue(radiusList, selectedRadius)}
                                />
                            )}
                        </div>

                        <div
                            style={{
                                width: props?.hideRadius
                                    ? '100%'
                                    : '60%',
                                marginLeft: '10px',
                                marginTop: '20px',
                            }}
                        >
                            <MyMapComponent
                                lat={
                                    locationData?.lat
                                        ? Number(locationData?.lat)
                                        : ''
                                }
                                lng={
                                    locationData?.lng
                                        ? Number(locationData?.lng)
                                        : ''
                                }
                                radius={selectedRadius || null}
                                handleMarkerDragEnd={
                                    handleMarkerDragEnd
                                }
                                scrollwheel={props?.scrollwheel}
                            />
                        </div>
                    </div>

                    <div className="register-step__footer">
                        <button
                            className="btn-next btn-next--yellow"
                            type="button"
                            onClick={handleApply}
                        >
                            Apply
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomGooglePlaceSearchV2